/** Nav section ids for sensor request rows under Field services (map shell). */
export const FIELD_SENSOR_SECTION = {
  ch4Awd: 'fieldSensorCh4',
  soilNutrient: 'fieldSensorSoil',
} as const;

export type FieldSensorSectionId = (typeof FIELD_SENSOR_SECTION)[keyof typeof FIELD_SENSOR_SECTION];

export function isFieldServiceSensorNavSection(id: string | null | undefined): boolean {
  return id === FIELD_SENSOR_SECTION.ch4Awd || id === FIELD_SENSOR_SECTION.soilNutrient;
}
